import keymirror from "../utils/keymirror";

export const UserProfileConstants = keymirror(
    {
        RESET_USER_PROFILE: null,

        USER_PROFILE_INIT: null,
        USER_PROFILE_INIT_SUCCESS: null,
        USER_PROFILE_INIT_FAILURE: null,

        USER_CORRECTIONS: null,
        USER_CORRECTIONS_SUCCESS: null,
        USER_CORRECTIONS_FAILURE: null,

        USER_POSTS: null,
        USER_POSTS_SUCCESS: null,
        USER_POSTS_FAILURE: null
    },
    "userprofile"
);



// WEBPACK FOOTER //
// ./src/constants/userProfile.constants.js